 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import A781642503944 from '@/components/9781642503944'
 import A7816425039441 from '@/components/97816425039441'
 import A7816425039442 from '@/components/97816425039442'
 import A7816425039443 from '@/components/97816425039443'
 import A7816425039444 from '@/components/97816425039444'
 import A7816425039445 from '@/components/97816425039445'
 import A7816425039446 from '@/components/97816425039446'
 import A7816425039447 from '@/components/97816425039447'
 import A7816425039448 from '@/components/97816425039448'
 import A7816425039449 from '@/components/97816425039449'
 import A78164250394410 from '@/components/978164250394410'
 import A78164250394411 from '@/components/978164250394411'
 import A78164250394412 from '@/components/978164250394412'
 import A78164250394414 from '@/components/978164250394414'
 import A78164250394415 from '@/components/978164250394415'
 import A78164250394416 from '@/components/978164250394416'
 import A78164250394417 from '@/components/978164250394417'
 import A78164250394418 from '@/components/978164250394418'
 import A78164250394419 from '@/components/978164250394419'
 import A78164250394420 from '@/components/978164250394420'
 import A78164250394421 from '@/components/978164250394421'
 import A78164250394422 from '@/components/978164250394422'
 import A78164250394423 from '@/components/978164250394423'
 import A78164250394424 from '@/components/978164250394424'
 import A78164250394425 from '@/components/978164250394425'
 import A78164250394426 from '@/components/978164250394426'
 import A78164250394427 from '@/components/978164250394427'
 import A78164250394428 from '@/components/978164250394428'
 import A78164250394429 from '@/components/978164250394429'
 import A78164250394430 from '@/components/978164250394430'
 import A78164250394431 from '@/components/978164250394431'
 import A78164250394432 from '@/components/978164250394432'
 import A78164250394433 from '@/components/978164250394433'
 import A78164250394434 from '@/components/978164250394434'
 import A78164250394435 from '@/components/978164250394435'
 import A78164250394436 from '@/components/978164250394436'
 import A78164250394437 from '@/components/978164250394437'
 import A78164250394438 from '@/components/978164250394438'
 import A78164250394439 from '@/components/978164250394439'
 import A78164250394440 from '@/components/978164250394440'
 import A78164250394441 from '@/components/978164250394441'
 import A78164250394442 from '@/components/978164250394442'
 import A78164250394443 from '@/components/978164250394443'
 import A78164250394444 from '@/components/978164250394444'
 import A78164250394445 from '@/components/978164250394445'
 import A78164250394446 from '@/components/978164250394446'
 import A78164250394447 from '@/components/978164250394447'
 import A78164250394448 from '@/components/978164250394448'
 import A78164250394449 from '@/components/978164250394449'
 import A78164250394450 from '@/components/978164250394450'
 import A78164250394451 from '@/components/978164250394451'
 import A78164250394452 from '@/components/978164250394452'
 import A78164250394453 from '@/components/978164250394453'
 import A78164250394454 from '@/components/978164250394454'
 import A78164250394455 from '@/components/978164250394455'
 import A78164250394456 from '@/components/978164250394456'
 import A78164250394457 from '@/components/978164250394457'
 import A78164250394458 from '@/components/978164250394458'
 import A78164250394459 from '@/components/978164250394459'
 import A78164250394460 from '@/components/978164250394460'
 import A78164250394461 from '@/components/978164250394461'
 import A78164250394462 from '@/components/978164250394462'
 import A78164250394463 from '@/components/978164250394463'
 import A78164250394464 from '@/components/978164250394464'
 import A78164250394465 from '@/components/978164250394465'
 import A78164250394466 from '@/components/978164250394466'
 import A78164250394467 from '@/components/978164250394467'
 import A78164250394468 from '@/components/978164250394468'
 import A78164250394469 from '@/components/978164250394469'
 import A78164250394470 from '@/components/978164250394470'
 import A78164250394471 from '@/components/978164250394471'
 import A78164250394472 from '@/components/978164250394472'
 import A78164250394473 from '@/components/978164250394473'
 import A78164250394474 from '@/components/978164250394474'
 import A78164250394475 from '@/components/978164250394475'
 import A78164250394476 from '@/components/978164250394476'
 import A78164250394477 from '@/components/978164250394477'
 import A78164250394478 from '@/components/978164250394478'
 import A78164250394479 from '@/components/978164250394479'
 import A78164250394480 from '@/components/978164250394480'
 import A78164250394481 from '@/components/978164250394481'
 import A78164250394482 from '@/components/978164250394482'
 import A78164250394483 from '@/components/978164250394483'
 import A78164250394484 from '@/components/978164250394484'
 import A78164250394485 from '@/components/978164250394485'
 import A78164250394486 from '@/components/978164250394486'
 import A78164250394487 from '@/components/978164250394487'
 import A78164250394488 from '@/components/978164250394488'
 import A78164250394489 from '@/components/978164250394489'
 import A78164250394490 from '@/components/978164250394490'
 import A78164250394491 from '@/components/978164250394491'
 import A78164250394492 from '@/components/978164250394492'
 import A78164250394493 from '@/components/978164250394493'
 import A78164250394494 from '@/components/978164250394494'
 import A78164250394495 from '@/components/978164250394495'
 import A78164250394496 from '@/components/978164250394496'
 import A78164250394497 from '@/components/978164250394497'
 import A78164250394498 from '@/components/978164250394498'
 import A78164250394499 from '@/components/978164250394499'
 import A781642503944100 from '@/components/9781642503944100'
 import A781642503944101 from '@/components/9781642503944101'
 import A781642503944102 from '@/components/9781642503944102'
 import A781642503944103 from '@/components/9781642503944103'
 import A781642503944104 from '@/components/9781642503944104'
 import A781642503944105 from '@/components/9781642503944105'
 import A781642503944106 from '@/components/9781642503944106'
 import A781642503944107 from '@/components/9781642503944107'
 import A781642503944108 from '@/components/9781642503944108'
 import A781642503944109 from '@/components/9781642503944109'
 import A781642503944110 from '@/components/9781642503944110'
 import A781642503944111 from '@/components/9781642503944111'
 import A781642503944112 from '@/components/9781642503944112'
 import A781642503944113 from '@/components/9781642503944113'
 import A781642503944114 from '@/components/9781642503944114'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9781642503944",
 			"name" : "9781642503944",
 			"component" : A781642503944
 		},
 		{
 			"path" : "/97816425039441",
 			"name" : "97816425039441",
 			"component" : A7816425039441
 		},
 		{
 			"path" : "/97816425039442",
 			"name" : "97816425039442",
 			"component" : A7816425039442
 		},
 		{
 			"path" : "/97816425039443",
 			"name" : "97816425039443",
 			"component" : A7816425039443
 		},
 		{
 			"path" : "/97816425039444",
 			"name" : "97816425039444",
 			"component" : A7816425039444
 		},
 		{
 			"path" : "/97816425039445",
 			"name" : "97816425039445",
 			"component" : A7816425039445
 		},
 		{
 			"path" : "/97816425039446",
 			"name" : "97816425039446",
 			"component" : A7816425039446
 		},
 		{
 			"path" : "/97816425039447",
 			"name" : "97816425039447",
 			"component" : A7816425039447
 		},
 		{
 			"path" : "/97816425039448",
 			"name" : "97816425039448",
 			"component" : A7816425039448
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js